import { Component, ElementRef, inject, Input, OnInit } from '@angular/core';
import { LeafletDirective } from '@bluehalo/ngx-leaflet';
import { Control, ControlPosition, DomUtil, Map } from 'leaflet';

@Component({
    template: '',
    standalone: false
})
export abstract class AbstractMapControlComponent implements OnInit {
  public readonly elementRef = inject(ElementRef);
  protected readonly leafletDirective = inject(LeafletDirective);

  protected control: Control;
  @Input() public controlPosition: ControlPosition;

  /**
   * Add the control to the leaflet's map
   */
  public ngOnInit(): void {
    const ComponentControl = Control.extend({
      onAdd: (_: Map) => {
        return DomUtil.get(this.elementRef.nativeElement.id);
      }
    });
    this.control = new ComponentControl({
      position: this.controlPosition
    }).addTo(this.leafletDirective.getMap());
  }
}
